export const TIMETABLE_FEATURE_KEY = 'timetable';
